import { DollarSign } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

function formatValue(v) {
  if (v == null || v === 0) return "R$ 0";
  if (v >= 1000) return "R$ " + (v / 1000).toFixed(1) + "k";
  return "R$ " + v.toFixed(0);
}

var STATUS_LABELS = { pendente: "Pendente", processando: "Processando", pago: "Pago", travada: "Travada" };
var STATUS_COLORS = {
  pendente: "bg-amber-100 text-amber-700", processando: "bg-blue-100 text-blue-700",
  pago: "bg-emerald-100 text-emerald-700", travada: "bg-red-100 text-red-700",
};

export default function CommissionsReport({ data }) {
  if (!data) return null;

  return (
    <div data-testid="commissions-report">
      <div className="grid grid-cols-2 gap-3 mb-6">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 bg-emerald-50 rounded-lg"><DollarSign className="w-4 h-4 text-emerald-500" /></div>
            <span className="text-xs text-gray-500">Valor Total</span>
          </div>
          <p className="text-2xl font-bold text-emerald-600" data-testid="comm-total-value">{formatValue(data.total_value)}</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <div className="flex items-center gap-2 mb-2">
            <div className="p-1.5 bg-blue-50 rounded-lg"><DollarSign className="w-4 h-4 text-[#3B82F6]" /></div>
            <span className="text-xs text-gray-500">Quantidade</span>
          </div>
          <p className="text-2xl font-bold text-[#0A2F3D]" data-testid="comm-total-count">{data.total_count}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <h4 className="text-sm font-semibold text-[#0A2F3D] mb-4">Evolucao Mensal</h4>
          <div className="h-48">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data.monthly}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="month" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} tickFormatter={function(v) { return formatValue(v); }} />
                <Tooltip formatter={function(v) { return formatValue(v); }} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Bar dataKey="total" name="Valor" fill="#10b981" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
          <h4 className="text-sm font-semibold text-[#0A2F3D] mb-4">Por Status</h4>
          <div className="space-y-3">
            {(data.by_status || []).map(function(s) {
              return (
                <div key={s.status}>
                  <div className="flex items-center justify-between mb-1">
                    <span className={"px-2 py-0.5 rounded-full text-xs font-medium " + (STATUS_COLORS[s.status] || "bg-gray-100 text-gray-700")}>{STATUS_LABELS[s.status] || s.status}</span>
                    <span className="text-xs font-semibold text-[#0A2F3D]">{formatValue(s.total)}</span>
                  </div>
                  <p className="text-xs text-gray-400">{s.count} comissao(oes)</p>
                </div>
              );
            })}
          </div>
          {(data.by_broker || []).length > 0 && (
            <div className="mt-4 pt-4 border-t border-gray-100">
              <h5 className="text-xs font-medium text-gray-500 mb-2">Top Corretores</h5>
              {data.by_broker.slice(0, 5).map(function(b) {
                return (
                  <div key={b.broker_id} className="flex items-center justify-between py-1">
                    <span className="text-xs text-gray-600 truncate max-w-[120px]">{b.broker_name}</span>
                    <span className="text-xs font-medium text-emerald-600">{formatValue(b.total)}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
